
// src/pages/Home.jsx

import React from 'react';

// Import components
import Hero from '../components/sections/Hero';
import AIFeatures from '../components/sections/AIFeatures';
import Team from '../components/sections/Team';
import Services from '../components/sections/Services';
// import Testimonials from '../components/sections/Testimonials';   // to add customer testimonial in future
// import Contact from '../components/sections/Contact';                //to add contact us page section in future
// Import the new ScheduleMeetingSection component instead of Contact
import ScheduleMeetingSection from '../components/sections/ScheduleMeetingSection';
import ValuesTopBanner from '../components/sections/ValuesTopBanner';

const Home = () => {
  return (
    <>
      <Hero />
      {/* AI Features section directly after the Hero section */}
      <AIFeatures />
      {/* Values banner */}
      <ValuesTopBanner />
      <Team />
      <Services />

      {/* Replace Contact with ScheduleMeetingSection */}
      <ScheduleMeetingSection />
    </>
  );
};

export default Home;